define(
    'viewmodels/site/__guardRoute',['lodash', 'atn/atn', 'dataSource/site'],
    function(_, atn, site) {
        'use strict';
        var fallbacks = {
            logout: '#site/error'
        };

        return {
            logout: guardLogout,
            error: guardError,
        };

        function guardLogout() {
            return atn.isLoggedOut() || fallbacks.logout;
        }

        function guardError() {
            if (!atn.showErrorPage) {
                _.defer(
                    atn.utils.redirect,
                    atn.utils.createURL(window.location.href, {})
                );
            }
            return atn.showErrorPage;
        }
    });
